<template>
  <div class="fullPage" style="color:#fff;">
   Drop Zone 
 <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-complete="afterComplete"></vue-dropzone>

  <div v-if="images.length>0" class="imageHolder">
    <div v-for="(image,i) in images" :key="'image'+i">
      <div class="baseImageLabel">{{image.name}}</div>
      <img :src="image.src"/>
    </div>
  </div>
  </div>
</template>

<script>

import firebase from 'firebase'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
let uuid = require('uuid')
export default {
  components: {
   vueDropzone: vue2Dropzone
  },
  data() {
    return {
     images:[],
     dropzoneOptions: {
          url: 'https://httpbin.org/post',
          thumbnailWidth: 250,
          maxFilesize: 2.5,
          acceptedFiles:".jpg,.png,.mp4",
          headers: { "My-Awesome-Header": "header value" }
      }
        }
  },
  mounted(){
      this.showImages()
    },
    computed:{
    
    },
    methods:{
      showImages(){
        const self=this
        var storageRef = firebase.storage().ref("images");
        // Now we get the references of these images
        storageRef.listAll().then(function(result) {
          console.log(result.items)
          result.items.forEach(function(imageRef) {
            // And finally display them
            displayImage(imageRef);
          });
        }).catch(function(error) {
          // Handle any errors
        });

        function displayImage(imageRef) {
          imageRef.getDownloadURL().then(function(url) {
            // TODO: Display the image on the UI
            
            self.images.push({name:imageRef.name,src:url})
          }).catch(function(error) {
            // Handle any errors
          });
        }
      },
     fileAdded(file){
       console.log(file)
     },
      async afterComplete(file){
        console.log(file.name)
        try{
          const imageName=uuid.v1()
          const metaData={
            contentType:"image/png"
          }
          const storageRef=firebase.storage().ref()
          const imageRef=storageRef.child('images/'+file.name)
          await imageRef.put(file,metaData);
          const imageInfo=await imageRef
          const downloadURL=await imageRef.getDownloadURL()
          console.log(imageInfo)
          this.images.push({name:file.name,src:downloadURL})
          this.$refs.myVueDropzone.removeFile(file)
        } catch(error){
          console.error(error )
        }

      }
    },
    watch:{
      
      
    },
  beforeDestroy() {
    
  },
}
</script>
<style>
.fullPage{
  height:calc(100% - 50px);
  overflow: hidden;
}

.docEdit{
   height:calc(100% - 60px);
  display:inline-flex;
  flex-direction:column; 
  overflow: hidden;
}
.docList{
   height:calc(100% - 60px);
   padding-top: 12px;
  display:inline-flex;
  flex-direction:column; 
  overflow: auto;
}
.imageHolder{
  position:relative;
  display: flex;
  flex-flow: row wrap;
  justify-content:space-evenly;
}
img{
  max-height:150px;
}
.baseImageLabel{
  position:absolute;
  bottom:0px;
}

</style>